import eventQueue from '../events/queue';
var eventEmitterReducer = function (store) {
    return function (next) {
        return function (action) {
            next(action);
            eventQueue.emit('state', {
                state: store.getState(),
                action: action.type,
                payload: action.payload,
            });
        };
    };
};
export default eventEmitterReducer;
